import * as React from "react";
import Loading from "../../../ui/loading/Loading";
import "../modal/partnerBrandJobTypesModal.scss";
import ButtonTertiary from "../../../../hiberUiKit/src/atoms/Buttons/ButtonTertiary";
import ButtonPrimary from "../../../../hiberUiKit/src/atoms/Buttons/ButtonPrimary";
import Modal from "../../../ui/modal/Modal";
import {none, option, Option, some} from "ts-option";
import {api} from "../../../../api/api";
import {notifyBugsnagAndShowToast} from "../../../../utils/Utils";
import Row from "../../../layout/Row";
import Col from "../../../layout/Col";
import Switch from "../../../../hiberUiKit/src/atoms/Switch/Switch";

import "./partnerBrandBoostersModal.scss"
import {BoostersLabel, BoostersMap, BoosterType} from "../../../../model/booster/Booster";
import Toast from "../../../helper/Toast";

interface IComponentProps {
	onFinish: () => void;
	partnerBrandId: string
}

interface State {
	boostersMap: Option<BoostersMap>,
	isLoading: boolean
}

type Props = IComponentProps

export default class PartnerBrandBoostersModal extends React.PureComponent<Props, State> {
	constructor(props: Props) {
		super(props);
		this.state = {
			boostersMap: none,
			isLoading: false
		}
	}

	componentDidMount() {
		api.instance.partnerBrandApi.fetchPartnerBrandBoosters(this.props.partnerBrandId)
			.then(boostersMap => this.setState({boostersMap: option(boostersMap)}))
			.catch(e => notifyBugsnagAndShowToast(e, "Fetch boosters"))
	}

	render() {
		return (
			<Modal onCloseClicked={this.props.onFinish} mediumWidth title={"Partner brand boosters configuration"}>
				<Loading isLoading={this.state.boostersMap.isEmpty}>
					<div className={"c-pb-boosters-modal-table"}>
						{this.state.boostersMap.map(map => Object.keys(map).map((item: BoosterType) => {

							return (
								<Row key={item}>
									<Col xl={4} md={4}>{BoostersLabel[item] || item}</Col>
									<Col xl={2} md={2}>
										<Switch checked={map[item]}
												onChange={value => this.changeBoosterState(item, value)}/>
									</Col>
								</Row>
							)
						})).orNull}
					</div>
					<div className="c-pb-job-type-modal-table_buttons-bar">
						<ButtonTertiary label={"Cancel"} onClick={this.props.onFinish}/>
						<ButtonPrimary isLoading={this.state.isLoading}
									   disabled={this.state.isLoading}
									   label={"Save configuration"}
									   onClick={this.saveConfiguration}/>
					</div>
				</Loading>
			</Modal>
		);
	}

	saveConfiguration = () => {
		this.state.boostersMap.map(
			boosters => api.instance.partnerBrandApi.savePartnerBrandBoosters(this.props.partnerBrandId, boosters)
				.then(() => {
					Toast.success("Boosters updated successfully", "Boosters update");
					this.props.onFinish()
				})
				.catch(e => notifyBugsnagAndShowToast(e, "Boosters update")))

	}

	changeBoosterState(item: BoosterType, value: boolean) {
		this.state.boostersMap.map(map => this.setState({boostersMap: some({...map, [item]: value})}));
	}
}